<template>
  <div class="master-detail">
    <div class="master">
      <div
        class="master-item"
        v-for="item in items"
        :key="item.id"
        @mouseover="debounceHandleMasterItemHover($event, item)"
        :class="activeItemId === item.id ? 'active' : ''"
      >
        <div class="icon-wrap">
          <img
            :src="getImageUrl(item.iconFilename)"
          />
        </div>
        <span v-text="item.title"/>
      </div>
    </div>
    <div class="detail">
      <div
        :ref="`detail-item-${item.id}`"
        class="detail-item"
        v-for="item in items"
        :key="item.id"
      >
        <img
          :src="getImageUrl(item.imageFilename)"
          :alt="item.title"
        />
        <p v-text="item.imageSubtext" class="top-pad-30"></p>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'MasterDetail',
  props: {
    items: Array
  },
  data () {
    return {
      activeItemId: ''
    };
  },
  created () {
    this.activeItemId = this.items[0].id;
  },
  mounted () {
    this.$activeDetailItem().addClass('active');
    this.debounceHandleMasterItemHover = debounce(
      this.handleMasterItemHover,
      300
    );
  },
  methods: {
    getImageUrl (filename) {
      return require(`../../assets/${filename}`);
    },
    handleMasterItemHover (event, item) {
      const $lastActiveDetailItem = this.$activeDetailItem();
      this.activeItemId = item.id;
      const $activeDetailItem = this.$activeDetailItem();

      const $imageElement = this.$activeDetailItem().children('img');
      let currentSource = $imageElement.attr('src');
      const queryIndex = currentSource.indexOf('?');
      if (queryIndex !== -1) {
        currentSource = currentSource.slice(0, queryIndex);
      }
      $imageElement.attr(
        'src',
        currentSource + '?' + Math.random()
      );

      $imageElement.get(0).onload = () => {
        $activeDetailItem.addClass('active');
      };

      $lastActiveDetailItem.removeClass('active');
    },
    $activeDetailItem () {
      return $(this.$refs[`detail-item-${this.activeItemId}`]);
    }
  }
};
</script>
